class QuantityInput extends HTMLElement {

    constructor() {
      super();
      this.input = this.querySelector('input');

      this.addBtn = this.querySelector('[name="plus"]');
      this.minusBtn = this.querySelector('[name="minus"]');

      this.input.addEventListener('change', this.onInputChange.bind(this));

      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }


    connectedCallback() {
      this.validateQtyRules();
    }


    onInputChange(event) {
      this.validateQtyRules();

      this.update();

    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;

      if (event.currentTarget.name === 'plus') {
        if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
          this.input.value = this.input.dataset.min;
        } else {
          this.input.stepUp();
        }
      } else {
        this.input.stepDown();
      }


      if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
        this.input.value = parseInt(this.input.min);
      }

      this.update();
    }


    update() {
      let updates = {}
      updates[this.dataset.variantId] = parseInt(this.input.value);

      CartManager.update(updates);
    }



    validateQtyRules() {
      const value = parseInt(this.input.value);

      if (this.input.min) {
        this.minusBtn.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
      }

      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.addBtn.classList.toggle('disabled', value >= max);
      }
    }
  }

  customElements.define('quantity-input', QuantityInput);
